import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import {
  faInfoCircle,
  faMinus,
  faPlus,
  faPlusCircle,
} from '@fortawesome/free-solid-svg-icons';
import { SharedDrawingModule } from '@iqd/shared-drawing';
import { SharedUtilsModule } from '@iqd/shared-utils';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AncillariesModalComponent } from './ancillaries-modal/ancillaries-modal.component';
import { AuthService } from './auth.service';
import { BayDistancesModalComponent } from './bay-distances-modal/bay-distances-modal.component';
import { FireRatingService } from './fire-rating.service';
import { FloorInfoComponent } from './floor-info/floor-info.component';
import { FormManagerService } from './form-manager.service';
import { GenerateFloorButtonComponent } from './generate-floor-button/generate-floor-button.component';
import { GridChangeService } from './grid-change.service';
import { ImportPolylineModalComponent } from './import-polyline-modal/import-polyline-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { InstallationService } from './installation.service';
import { IsBudgetQuoteDirective } from './is-budget-quote.directive';
import { IsDistributorQuoteDirective } from './is-distributor-quote.directive';
import { IsInternalQuoteDirective } from './is-internal-quote.directive';
import { LoadingViewComponent } from './loading-view/loading-view.component';
import { PlantAncillariesService } from './plant-ancillaries.service';
import { QuoteAncillariesComponent } from './quote-ancillaries/quote-ancillaries.component';
import { QuoteDeckingComponent } from './quote-decking/quote-decking.component';
import { QuoteFireRatingComponent } from './quote-fire-rating/quote-fire-rating.component';
import { QuoteGeneralComponent } from './quote-general/quote-general.component';
import { QuoteGridComponent } from './quote-grid/quote-grid.component';
import { QuoteLoadTypeComponent } from './quote-load-type/quote-load-type.component';
import { QuoteSessionService } from './quote-session.service';
import { QuoteTiersComponent } from './quote-tiers/quote-tiers.component';
import { TransformComponentsService } from './transform-components.service';
import { TransportService } from './transport.service';

export interface AppState {
  auth: any;
  settings: any;
  forms: any;
  dashboard: any;
}

@NgModule({
  declarations: [
    GenerateFloorButtonComponent,
    InfoModalComponent,
    LoadingViewComponent,
    BayDistancesModalComponent,
    QuoteGeneralComponent,
    IsBudgetQuoteDirective,
    IsDistributorQuoteDirective,
    IsInternalQuoteDirective,
    QuoteFireRatingComponent,
    QuoteAncillariesComponent,
    AncillariesModalComponent,
    FloorInfoComponent,
    QuoteGridComponent,
    ImportPolylineModalComponent,
    QuoteTiersComponent,
    QuoteLoadTypeComponent,
    QuoteDeckingComponent,
  ],
  imports: [
    SharedUtilsModule,
    NgbModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedDrawingModule,
  ],
  exports: [
    GenerateFloorButtonComponent,
    BayDistancesModalComponent,
    QuoteGeneralComponent,
    QuoteFireRatingComponent,
    QuoteAncillariesComponent,
    FloorInfoComponent,
    QuoteGridComponent,
    QuoteTiersComponent,
    QuoteLoadTypeComponent,
    QuoteDeckingComponent,
    AncillariesModalComponent,
    LoadingViewComponent,
  ],
  providers: [
    FormManagerService,
    TransformComponentsService,
    GridChangeService,
    InstallationService,
    TransportService,
    FireRatingService,
    PlantAncillariesService,
    QuoteSessionService,
    AuthService,
  ],
})
export class SharedQuotingModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faPlus,
      faMinus,
      faPlusCircle,
      faCalendarAlt,
      faInfoCircle
    );
  }
}
